export class Book {
    authors:string[];
    title:string;
    subtitle:string;
    publisher:string;
    publicationDate:string;
    description:string;
    numberOfPages:number;
    googleId:string;
    isbn:string;
    viewability:string;
    previewLinks:{[type:string]: string};
    textSnippet:string;

    static fromItem = (item:any):Book => {
        var book = new Book();
        book.googleId = item.id;

        if (item.volumeInfo) {
            book.authors = item.volumeInfo.authors ? item.volumeInfo.authors : null;
            book.title = item.volumeInfo.title ? item.volumeInfo.title : null;
            book.subtitle = item.volumeInfo.subtitle ? item.volumeInfo.subtitle : null;
            book.publisher = item.volumeInfo.publisher ? item.volumeInfo.publisher : null;
            book.publicationDate = item.volumeInfo.publishedDate ? item.volumeInfo.publishedDate : null;
            book.description = item.volumeInfo.description ? item.volumeInfo.description : null;
            book.numberOfPages = item.volumeInfo.pageCount ? item.volumeInfo.pageCount : null;
    
            if (item.volumeInfo.industryIdentifiers) {
                var ISBN10 = null;
                var ISBN13 = null
                item.volumeInfo.industryIdentifiers.forEach(function(id) {
                    if (id.type === "ISBN_13") {
                        ISBN13 = id.identifier;
                    } else if (id.type === "ISBN_10") {
                        ISBN10 = id.identifier;
                    }
                })
                book.isbn = ISBN13 ? ISBN13 : ISBN10;
            }
        }
    
        if (item.accessInfo) {
            book.viewability = item.accessInfo.viewability ? item.accessInfo.viewability : null;
            if (item.accessInfo.viewability === "PARTIAL" || item.accessInfo.viewability === "ALL_PAGES") {
                book.previewLinks = {};
                if (item.accessInfo.epub && item.accessInfo.epub.isAvailable) {
                    book.previewLinks.epub = item.accessInfo.epub.downloadLink || item.accessInfo.epub.acsTokenLink;
                }
                
                if (item.accessInfo.pdf && item.accessInfo.pdf.isAvailable) {
                    book.previewLinks.pdf = item.accessInfo.pdf.downloadLink || item.accessInfo.pdf.acsTokenLink;
                }
                
            }
        }
    
        if (item.searchInfo) {
            book.textSnippet = item.searchInfo.textSnippet ? item.searchInfo.textSnippet : null;
        }
    
        return book;
    }
}




// WEBPACK FOOTER //
// ./web/static/services/GoogleData/Book.ts